import { render } from "./actions.vue?vue&type=template&id=4591fb91"
const script = {}

import exportComponent from "D:\\All Sites\\Trial Sites\\vue_13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__